<template>
    <div class="mt-4 p-0 mr-0 ml-0 mb-0 d-print-none">
        <v-row dense class="d-print-none">
             <v-col cols="12" sm="12" md="3">
                <v-btn
                    @click.prevent="backFilter()" 
                    :class="$css_button"
                    outlined
                    :block="$vuetify.breakpoint.smAndDown"
                >
                    <v-icon left>
                        mdi-chevron-left
                    </v-icon>
                    Voltar para pesquisa
                </v-btn>
            </v-col>
            <v-col v-if="facs && facs.meta && facs.meta.total && facs.meta.total > 0" cols="12" sm="12" md="9" class="text-right">
                <order-new-component 
                    :object="items_order"
                    @callLoadItems="changeOrder"
                />
            </v-col>
        </v-row>
    
        <template v-if="facs && facs.meta && facs.meta.total && facs.meta.total > 0">
            <v-row v-if="facs.meta" class="mt-2 mb-2">    
                <v-col cols="12" sm="12" md="6">
                    <div class="text-h6">Total: {{ facs.meta.total }} -  Página {{ facs.meta.current_page }} de {{ facs.meta.last_page }}</div>
                </v-col>
                <v-col cols="12" sm="12" md="6">
                    <pagination-component 
                        :meta="facs.meta"
                        @page-changed="changePage"
                    />
                </v-col>    
            </v-row>
            <v-row dense class="d-print-none">
                <v-col>
                    <result-list v-if="facs.data" :items="facs.data" />
                </v-col>
            </v-row>
            <v-row v-if="facs.meta" class="mt-2 mb-2">    
                <v-col cols="12" sm="6" md="6">
                    <div class="text-h6">Total: {{ facs.meta.total }} -  Página {{ facs.meta.current_page }} de {{ facs.meta.last_page }}</div>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                    <pagination-component 
                        :meta="facs.meta"
                        @page-changed="changePage"
                    />
                </v-col> 
            </v-row>
        </template>

        <template v-else>
            <div class="mt-6" v-if="facs.meta">
                <v-alert
                    type="error"
                >
                    Nenhum registro encontrado 
                </v-alert>
            </div>
        </template>


    </div>
</template>

<script>
import PaginationComponent from '@/components/pagination/PaginationComponent.vue';
import OrderNewComponent from '@/components/order/OrderNewComponent.vue';
import ResultList from './ResultList.vue';
import qs from 'qs';

export default {
    components: {
        ResultList,
        PaginationComponent,
        OrderNewComponent
    },

    data () {
        return {
            facs: {},

            items_order: {
                current_order: { 
                    value: 'facs.updated_at', 
                    description: 'Data de atualizaçāo',
                    sense: 'desc',
                    sense_description: 'maior -> menor',
                    params: ''
                },
                sense: [
                    { value: 'asc', description: 'menor -> maior' },
                    { value: 'desc', description: 'maior -> menor' },
                ],
                items:[
                    {
                        value: 'facs.created_at', 
                        description: 'Data cadastro'
                    },
                    {
                        value: 'facs.data_atualizacao', 
                        description: 'Data de atualizaçāo'
                    },
                    {
                        value: 'facs.status', 
                        description: 'Status'
                    },    
                ] 
            },
        }
    },  
    
    mounted() {
        window.scrollTo(0, 0);    

        // Extrai e faz parse da query string com suporte a arrays
        const fullPath = this.$route.fullPath;
        const queryString = fullPath.split('?')[1]; // tudo depois do ?
        const query = queryString ? qs.parse(queryString, { arrayFormat: 'brackets' }) : {};

        if(query.multiple_status && query.multiple_status !== ''){
            const status = query.multiple_status;
            // Converte para array se for string
            const statusArray = Array.isArray(status) ? status : [status];
            query.multiple_status = statusArray;
        }
  
        const current_order = this.items_order.current_order;
        const page = query.page ? Number(query.page) : 1;

        const filters = {
            ...query,
            page,
            order: current_order.value,
            sense: current_order.sense
        };

        // Limpe valores nulos/vazios (opcional, mas recomendado)
        Object.keys(filters).forEach(key => {
            if (filters[key] === null || filters[key] === '') {
            delete filters[key];
            }
        });

        this.loadMoreFacs(filters);
    },

    methods: {
        async loadMoreFacs(params = null) {
            console.log(params);
            try {
                const response = await this.$store.dispatch('loadPromisseFacs', params);
                this.facs = response;
            } catch (error) {
                console.error('Erro ao carregar propriedades:', error);
                // Opcional: exibir mensagem ao usuário
                this.$toast.error('Falha ao carregar os dados. Tente novamente.');
            }
        },

        backFilter(){
            const filters = { ...this.$route.query}; // Cópia direta dos parâmetros
            
            this.$router.push({
                name: 'admin.facs2.filter',
                query: filters
            });
            
        },

        changePage(page) {
            const query = { ...this.$route.query };
            const order = this.items_order.current_order.value;
            const sense = this.items_order.current_order.sense;

            // Garanta que a página seja um número válido
            const pageSafe = page && !isNaN(page) ? Number(page) : 1;

            const filters = {
                page: pageSafe,
                order,
                sense,
                ...query
            };

            // Remova valores undefined ou nulos
            Object.keys(filters).forEach(key => {
                if (filters[key] == null || filters[key] === '') {
                    delete filters[key];
                }
            });
            
            this.loadMoreFacs(filters);
        },

        changeOrder(params){
            window.scrollTo(0, 0);
            this.items_order.current_order.value = params.order;
            const items = this.items_order.items.filter( model => model.value == params.order);
            if(items && items.length > 0){
                this.items_order.current_order.description = items[0].description;
            }

            this.items_order.current_order.sense = params.sense;
            const sense_items = this.items_order.sense.filter( model => model.value == params.sense);
            if(sense_items && sense_items.length > 0){
                this.items_order.current_order.sense_description = sense_items[0].description;
            }

            const filters = { ...this.$route.query, page: 1, order: params.order, sense: params.sense }; // Cópia direta dos parâmetros
            this.loadMoreFacs(filters);
        }
    }
}

</script>
